<template>
    <div class='sk__listCard'>
        <div class="sk__listCard-control sk__listCard-control_desktop">
            <div class="sk__listCard-control-left">
                <div class="sk__listCard-control-left-search elem"></div>
                <div class="sk__listCard-control-left-button elem"></div>
            </div>
            <div class="sk__listCard-control-sorting elem"></div>
        </div>
        <div class="sk__listCard-control sk__listCard-control_mobile">
            <div class="sk__listCard-control-left-search elem"></div>
            <div class="sk__listCard-control-left">
                <div class="sk__listCard-control-left-button elem"></div>
                <div class="sk__listCard-control-sorting elem"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

};
</script>

<style scoped lang='less'>
@import "theme/moydom/less/variables.less";
.sk {
    &__listCard {
        &-control {
            display: flex;
            justify-content: space-between;
            margin: 40px 0;

            &-left {
                display: flex;
                gap: 25px;
                width: 100%;

                @media (max-width: @screen-xs) {
                    margin-top: 20px;
                    width: 100%;
                    align-items: baseline;
                    justify-content: space-between;
                }

                &-search {
                    width: 45%;
                    border-radius: 6px;
                    height: 40px;
                }

                &-button {
                    height: 40px;
                    border-radius: 6px;
                    width: 10%;
                }
            }

            &-sorting {
                border-radius: 6px;
                height: 40px;
                width: 10%;
            }

            &_desktop {
                @media (max-width: @screen-xs) {
                    display: none;
                }
            }

            &_mobile {
                display: none;

                @media (max-width: @screen-xs) {
                    display: block;
                }
            }
        }
    }
}

.w100 {
    width: 100%;
}

.w70 {
    width: 70%;
}

.w40 {
    width: 40%;
}

.elem {
    background: #EAEDF0;
    position: relative;
    overflow: hidden;

&::after {
     position: absolute;
     top: 0;
     right: 0;
     bottom: 0;
     left: 0;
     transform: translateX(-100%);
     background: linear-gradient(90deg,
     transparent 0%,
     #c3c3c361 30%,
     transparent 100%);
     animation: load 2s infinite;
     content: '';
 }
}

@keyframes load {
    100% {
        transform: translateX(100%);
    }
}
</style>
